export default "__VITE_ASSET__C1GoG7Ka__"